import { UtilHelper } from '../helpers/utils.helper';

export class Address {
  id: number;
  userId?: number;
  street: string;
  number: string;
  complement: string;
  neighborhood: string;
  landmark?: string;
  zipCode: string;
  state: string;
  city: string;
  description: string;
  lat?: number;
  lon?: number;
  foreigner?: boolean;
  country?: string; //"BR"

  // Usado no drive-in
  car?: string;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
  }

  getFullFormattedAddress(withZipCode?: boolean): string {
    let address: string = '';
    if (this.street) {
      address += this.street;
    }
    if (this.number) {
      address += ', ' + this.number + ', '; // + "<br>";
    }
    if (this.complement) {
      address += this.complement;
    }
    if (this.neighborhood) {
      address += (this.complement ? ' - ' : '') + this.neighborhood;
    }
    if (this.city) {
      address += ', ' + this.city;
    }
    if (this.state) {
      address += ' - ' + this.state;
    }
    if (withZipCode && this.zipCode) {
      address += ', ' + this.zipCode;
    }
    return address;
  }

  getShortAddress(): string {
    return this.getStreetFormattedAddress() + ', ' + this.getComplementFormattedAddress();
  }

  getStreetFormattedAddress(): string {
    let address: string = '';
    if (this.street) {
      address += this.street;
    }
    if (this.number) {
      address += ', ' + this.number;
    }
    return address;
  }

  // Ap 2 - Centro, Curitiba - PR
  getComplementFormattedAddress(): string {
    let address: string = '';
    if (this.complement) {
      address += this.complement;
    }
    if (this.neighborhood) {
      address += (address ? ' - ' : ' ') + this.neighborhood;
    }
    if (this.city) {
      address += ', ' + this.city;
    }
    if (this.state) {
      address += ' - ' + this.state;
    }
    return address;
  }

  toJson(): any {
    return {
      id: this.id,
      userId: this.userId,
      street: this.street,
      number: this.number,
      complement: this.complement || '-',
      neighborhood: this.neighborhood,
      landmark: this.landmark || '-',
      zipCode: UtilHelper.unmask(this.zipCode),
      state: this.state,
      city: this.city,
      description: this.description,
      lat: this.lat,
      lon: this.lon,
      foreigner: this.foreigner != null ? this.foreigner : false,
      country: this.country || 'BR',
      car: this.car,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/address.model.ts